import './vendor-jquery';

import * as angular from 'angular';
import { setAngularJSGlobal } from '@angular/upgrade/static';
import 'angular-material';
import 'angular-animate';
import 'angular-aria';
import 'angular-material-icons';
import 'node_modules/@caslink/theme/casLinkThemeColors';
import 'node_modules/@captiveaire/eventbus/dist/eventBus';
import 'node_modules/jsonformatter/dist/json-formatter';

import 'angular-moment';
import '../CASLink-Common-Client/src/app';
import 'node_modules/@captiveaire/dynamicelement/dist/dynamicElement';

import 'signalr';

// ideally the below would not be here, and would be imported directly by
// the modules that use them. (I.e. would never be access via globals, nor need to be injected.)
// that would allow them to be moved to lazy loaded chunks when possible.
import 'lodash';
import 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/no-data-to-display';

setAngularJSGlobal(angular);

